<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="车牌号/终端主机号"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
<!--      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcelClick">导出</Button>-->
      <Button size="small" type="primary" style="margin-right: 3px;" @click="jt808AddSengcmdModal=true">
        下发指令
      </Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="jt808BatchAddSengcmdModal=true">
        批量下发指令
      </Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="closeall">
        关闭所有指令
      </Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage" show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>


    <jt808-add-sengcmd-modal v-model="jt808AddSengcmdModal" :initValue="jt808AddSengcmdId" @on-success="onSuccess"></jt808-add-sengcmd-modal>
    <jt808-batch-add-sengcmd-modal v-model="jt808BatchAddSengcmdModal" :initValue="jt808BatchAddSengcmdId" @on-success="onSuccess"></jt808-batch-add-sengcmd-modal>

    <jt808-sengcmd-detail-modal v-model="jt808SengcmdDetailModal" :initValue="jt808SengcmdDetailId" @on-success="onSuccess"></jt808-sengcmd-detail-modal>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal" @on-column-update="onColumnUpdate"></web-table-columns-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'
  import { genURLParams } from '@/libs/urlparamhelper'

  import Jt808AddSengcmdModal from '@/view/ddm/components/jt808-add-sendcmd-modal'
  import Jt808BatchAddSengcmdModal from '@/view/ddm/components/jt808-batch-add-sendcmd-modal'
  import Jt808SengcmdDetailModal from '@/view/ddm/components/jt808-sendcmd-detail-modal'


  export default {
        name: "jt808sendcmd",
    components:{
      Jt808AddSengcmdModal,
      Jt808BatchAddSengcmdModal,
      Jt808SengcmdDetailModal,
    },
      data(){
          return{
            //增加下发指令记录
            jt808AddSengcmdModal:false,
            jt808AddSengcmdId:null,

            //批量增加下发指令记录
            jt808BatchAddSengcmdModal:false,
            jt808BatchAddSengcmdId:null,

            //查询/修改下发指令记录
            jt808SengcmdDetailModal:false,
            jt808SengcmdDetailId:null,

            webTableColumnsModal: false,
            menuList: [
              { title: '设置表格列', content: {} }
            ],

            pageFilter: 30,
            pagesizeopts: [30, 50, 100, 200],
            keywordFilter: null,
            tableHeight: 160,
            pageIndex: 1,
            sort: null,
            listLoadding: false,

            columns: [
              {
                title: 'ID',
                resizable: true,
                key: 'id',
                sortable: 'custom',
                tooltip: 'true',
                width: 100
              },
              {
                title: '主机号',
                resizable: true,
                key: 'terminalNum',
                ellipsis: 'true',
                width: 150
              },
              {
                title: '设备型号',
                resizable: true,
                key: 'positioningDeviceModelId',
                ellipsis: 'true',
                width: 150,
                filters: [
                ],
                // filterMultiple: false,
                // filterRemote: (val) => {
                //   if (val.length > 0) {
                //     this.positioningDeviceModelFilter = genQueryParam('positioningDeviceModelId', 'EQ', val[0])
                //   } else {
                //     this.positioningDeviceModelFilter = null
                //   }
                // },
                render: function (h, params) {
                  console.log(params.row)
                  if (params.row.positioningDeviceInfo) {
                    if (params.row.positioningDeviceInfo.positioningDeviceModel) {
                      let positioningDeviceModel = params.row.positioningDeviceInfo.positioningDeviceModel
                      return h('div', positioningDeviceModel.name)
                    }else {
                      return h('div', '未知')
                    }
                  } else {
                    return h('div', '未知')
                  }
                }
              },
              {
                title: '车牌号',
                resizable: true,
                key: 'vehicleInfoId',
                ellipsis: 'true',
                width: 120,
                render: (h, params) => {
                  if (params.row.positioningDeviceInfo) {
                    if (params.row.positioningDeviceInfo.vehicleInfo) {
                      if (params.row.positioningDeviceInfo.vehicleInfo.registrationNum) {
                        return h('div', params.row.positioningDeviceInfo.vehicleInfo.registrationNum)
                      } else {
                        return h('div', '无')
                      }
                    }else {
                      return h('div', '未绑定车辆信息')
                    }
                  } else {
                    return h('div', '未绑定车辆信息')
                  }
                }
              },
              {
                title: '指令列表',
                resizable: true,
                key: 'cmdList',
                ellipsis: 'true',
                tooltip: 'true',
                width: 600,
                render: function (h, params) {
                  let cmdList = []
                  if (params.row.firstcmd) {
                    cmdList.push(params.row.firstcmd)
                  }
                  if (params.row.secondcmd) {
                    cmdList.push(params.row.secondcmd)
                  }
                  if (params.row.thirdcmd) {
                    cmdList.push(params.row.thirdcmd)
                  }
                  if (params.row.fourthcmd) {
                    cmdList.push(params.row.fourthcmd)
                  }
                  if (params.row.fifthcmd) {
                    cmdList.push(params.row.fifthcmd)
                  }
                  if (params.row.sixthcmd) {
                    cmdList.push(params.row.sixthcmd)
                  }
                    return h('div', cmdList.toString())
                }
              },
              {
                title: '设备上线自动下发',
                resizable: true,
                key: 'automaticSending',
                ellipsis: 'true',
                tooltip: 'true',
                width: 100
              },
              {
                title: '定时下发',
                resizable: true,
                key: 'timedTransmission',
                ellipsis: 'true',
                tooltip: 'true',
                width: 100
              },
              {
                title: '定时下发时间间隔',
                resizable: true,
                key: 'intervalTime',
                ellipsis: 'true',
                tooltip: 'true',
                width: 100
              },
              {
                title: '下发结果',
                resizable: true,
                key: 'result',
                ellipsis: 'true',
                tooltip: 'true',
                width: 100
              },
              {
                title: '创建人',
                resizable: true,
                ellipsis: 'true',
                tooltip: 'true',
                key: 'createUser',
                width: 120,
                render: function (h, params) {
                  if (params.row.createUser) {
                    let createUser = params.row.createUser
                    return h('div', createUser.realName)
                  }
                }
              },
              {
                title: '创建时间',
                resizable: true,
                sortable: 'custom',
                ellipsis: 'true',
                tooltip: 'true',
                key: 'createDatetime',
                width: 160,
                render: function (h, params) {
                  if (params.row.createDatetime) {
                    let d = new Date(params.row.createDatetime)
                    return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
                  }
                }
              },
              {
                title: '历史记录',
                resizable: true,
                key: 'historyRecord',
                ellipsis: 'true',
                tooltip: 'true',
                minWidth: 150
              },
              {
                title: '操作',
                resizable: true,
                key: 'action',
                align: 'left',
                ellipsis: 'true',
                minWidth: 180,
                fixed: 'right',
                render: (h, params) => {
                  return h('div', [
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.jt808SengcmdDetailId = params.row.id
                          this.jt808SengcmdDetailModal = true
                        }
                      }
                    }, '详细信息'),
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '<p>确认删除</p>',
                            onOk: () => {
                              store.dispatch('SendCmdServ_DeleteObj', {
                                params: { id: params.row.id }
                              }).then(() => {
                                this.$Message.success('删除完成')
                                this.refreshPage()
                              }).catch(err => {
                                this.$Message.error(err)
                              })
                            },
                            onCancel: () => {

                            }
                          })
                        }
                      }
                    }, '删除')
                  ])
                }
              }
            ]// cloumn
          }
      },
      methods:{

        /**
         * 表格右键回调
         */
        onTableRightClick (e) {
          this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
        },
        /**
         * 右键菜单点击回调
         */
        onContextMenuCallback (item) {
          if (item.title === '设置表格列') {
            this.webTableColumnsModal = true
          }
        },

        onFilterClick () {
          this.setPage(1)
        },
        sortChange ({ column, key, order }) {
          this.sort = {
            name: key,
            asc: order === 'asc'
          }
          this.refreshPage(this.pageFilter)
        },
        filterChange () {
          this.refreshPage(this.pageFilter)
        },
        setPage(page){
          console.log('setPage' + page)
          this.pageIndex = page
          this.listLoadding = true

          let queryParams = []
          let sortParam = null

          if (this.sort) {
            sortParam = genSortParam(this.sort.name, this.sort.asc)
          }

          if (this.sourceTypeFilter) {
            queryParams.push(this.sourceTypeFilter)
          }
          if (this.positioningDeviceModelFilter) {
            queryParams.push(this.positioningDeviceModelFilter)
          }

          store.dispatch('SendCmdServ_GetPage', {
            params: null,
            urlparams: {
              q: queryParams,
              ps: this.pageFilter,
              p: page,
              keyword: this.keywordFilter,
              sort: sortParam
            }
          }).then(() => {
            this.listLoadding = false
            this.onColumnUpdate()
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        },
        // 刷新当前页
        refreshPage (value) {
          this.pageFilter = value
          this.setPage(this.pageIndex)
        },
        onSuccess () {
          this.refreshPage(this.pageFilter)
        },
        onColumnUpdate () {
          for (let i = 0; i < this.columns.length; i++) {
            if (this.columns[i].title === '设备型号') {
              this.columns[i].filters = this.positioningDeviceModelOptions
              break
            }
          }
        },
        closeall(){
          store.dispatch('SendCmdServ_CloseAll',{
            params:null,
            urlparams:null
          }).then(res => {
            console.log(res)
            this.onSuccess()
          }).catch(err => {
            console.log(err)
          })
        }
      },
      computed: {
        totalElements () {
          if (store.getters.get_SendCmd_GetPageResult) {
            return store.getters.get_SendCmd_GetPageResult.totalElements
          } else {
            return 0
          }
        },
        content () {
          if (store.getters.get_SendCmd_GetPageResult) {
            return store.getters.get_SendCmd_GetPageResult.content
          } else {
            return []
          }
        },
        pageSize () {
          if (store.getters.get_SendCmd_GetPageResult) {
            return store.getters.get_SendCmd_GetPageResult.size
          } else {
            return 0
          }
        }
      },
      mounted() {
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
          window.onresize = () => {
            this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
          }
          this.setPage(1)
        })
      }
    }
</script>

<style scoped>

</style>
